import { AUTHENTICATION_SERVICE } from './index';
import { IAuthenticationService } from './authentication.interface';
import { interfaces as inversifyInterfaces } from 'inversify';
import { OFX_AUTH_CONFIG } from '../../helpers/app-config';

export function getAuthenUrl(): string {
    const { PROTOCOL, PORT, GATEWAY_ADDRESS } = OFX_AUTH_CONFIG;

    return `${ PROTOCOL }://${ GATEWAY_ADDRESS }:${ PORT }/ofxapi/v1/auth/userpass`;
}

export function authenticationFactory(container: inversifyInterfaces.Container): IAuthenticationService {
    const isLogged = Boolean(JSON.parse(sessionStorage.getItem('SFX_IS_LOGGED')));

    /**
     * NOTE: We cannot provide the authentication service as long as the authentication
     * method has not been chosen.
     */
    if (!isLogged) {
        return undefined;
    }

    const authenticationMode = sessionStorage.getItem('SFX_AUTH_MODE');
    switch (authenticationMode) {
        case 'mock':
            return container.getNamed(AUTHENTICATION_SERVICE, 'mock');
        case 'form':
            return container.getNamed(AUTHENTICATION_SERVICE, 'form');
        case 'portal':
            return container.getNamed(AUTHENTICATION_SERVICE, 'portal');
        default:
            throw new Error(`[authenfificationFactory] No injection defined for ${ authenticationMode }.`);
    }
}
